<div *ngIf="totals" class="float">
    Total Float
    <div class="amount">{{ totals.FLOAT | currency:totals.currency }}</div>
    Total Users
    <div class="amount">{{ globalTotals.USERS }}</div>
</div>